// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    PRODUCT_INDEX_PAGE_LOADING() {
      return {
        isLoading: true,
        productIndexPage: action.productIndexPage
      };
    },
    PRODUCT_INDEX_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.productIndexPage
      };
    },
    PRODUCT_INDEX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.productIndexPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
